import { css } from 'styled-components';

type StateBlockProps = { bg: string; border: string; color: string };

export const stateBlock = ({ bg, border, color }: StateBlockProps) => css`
  background-color: ${bg};
  border-color: ${border};
  color: ${color};
  svg {
    color: ${color};
  }
`;
